export const pbsGroup = {
    breadcrumb: {
        pbsGroup: 'PBS group',
        admin: 'Admins',
    },
    title: {
        pbsGroup: 'PBS group',
        pbsGroupInformation: 'PBS group information',
        addUser: 'Add user to PBS group',
        addGroup: 'Add group to PBS group',
        createPbsGroup: 'Create a PBS group',
        updatePbsGroup: 'Update PBS group',
        deletePbsGroup: 'Delete PBS group',
        removeUser: 'Remove user',
        removeGroup: 'Remove group',
        userList: 'User list',
        groupList: 'Group list',
    },
    button: {
        save: 'Save',
        create: 'Create',
        edit: 'Edit',
        delete: 'Delete',
        addUser: 'Add User',
        addGroup: 'Add Group',
    },
    label: {
        pbsGroupName: 'PBS group name',
        user: 'User',
        group: 'Group',
        email: 'Email',
        fullName: 'Full name',
        ldapUsername: 'LDAP username',
        projectProfile: 'Project profile',
        projectProfileByPbs: 'Project profile by PBS',
        action: 'Action',
        groupName: 'Name',
        description: 'Description',
    },
    placeholder: {
        pbsGroupName: 'Enter PBS group name',
        user: 'Select a user',
        group: 'Select a group',
        profile: 'Select a project profile',
    },
    message: {
        userRequired: 'The user field is required',
        groupRequired: 'The group field is required',
        confirmDeletePbsGroup: 'Are you sure to delete this PBS group?',
        confirmRemoveUser: 'Are you sure to remove this user?',
        confirmRemoveGroup: 'Are you sure to remove this group?',
        deletePbsGroupSuccess: 'Delete PBS group successful',
        removeUserSuccess: 'Remove user successful',
        removeGroupSuccess: 'Remove group successful',
        userNotExit: 'This user does not exit',
        groupNotExit: 'This group does not exit',
        addUserSuccess: 'Add user successful',
        addGroupSuccess: 'Add group successful',
        createPbsGroupSuccess: 'Create PBS group successful',
        updatePbsGroupSuccess: 'Update PBS group successful',
        updateUserSuccess: 'Update user successful',
    },
    tooltip: 'Right click to see options',
};
